<div class="session-task">
  <div
    class="session-task-image"
    [ngClass]="{
      'urgent': taskStatus() === sessionTaskStatus.URGENT,
    }"
  >
    @switch (taskType()) {
      @case (sessionTaskType.ACCOUNT_INFO) {
        <img src="/assets/diamond-warning.svg" alt="Warning" />
      }
      @case (sessionTaskType.DOCUMENTS) {
        <img src="/assets/signature.svg" alt="Signature" />
      }
      @case (sessionTaskType.ASSESSMENTS) {
        <img src="/assets/assessments.svg" alt="Assessments" />
      }
    }
    @switch (taskStatus()) {
      @case (sessionTaskStatus.COMPLETED) {
        <div class="session-task-image-status" [ngClass]="taskStatus()">
          <iris-icon
          [size]="iconSizes.SM"
          name="check"
          [color]="iconColors.WHITE"
        ></iris-icon>
        </div>
      }
    }
  </div>
  <div class="session-task-content">
    <div class="session-task-content-title">
      {{ title() }}
    </div>
    <div class="session-task-content-description" [ngClass]="taskStatus()">
      {{ description() }}
    </div>
  </div>
</div>

